<template>
  <div v-if="isDreal">
    <!-- Alertes -->
    <div
      class="alert alert-warning"
      :class="{ 'mb-4': !isAutorisation }"
      role="alert"
      v-if="isAnteDebutConstruction"
    >
      Les données techniques sont susceptibles d'évoluer tant que le
      chantier de construction n'a pas débuté.
    </div>
    <div class="alert alert-info" role="alert" v-if="isLock">
      La saisie du parc est bloquée par l'utilisateur {{ parc.mailVerrou }}
    </div>

    <!-- Bouttons DREAL -->
    <div class="btn-group mb-4 parc-btn--dreal" role="group" aria-label="Basic example">
      <b-button
        class="me-2 my-2 rounded"
        variant="success"
        size="sm"
        icon
        id="dreal-show-all"
        @click="showModalAll()"
      >
        <i class="fa fa-info"></i>
        <b-tooltip target="#dreal-show-all">
          Afficher la vue d'ensemble des données du parc {{ parc.id }}
        </b-tooltip>
      </b-button>
      <b-button
        variant="success"
        class="me-2 my-2 rounded"
        :disabled="isLock"
        v-if="showDrealEditBtn()"
        id="dreal-editer"
        @click="onClickEditer()"
      >
        <span class="parc-btn-label">Modifier</span>
        <i class="fa fa-edit parc-icon"></i>
        <b-tooltip target="#dreal-editer">
          Mettre à jour les informations saisies par l'exploitant
        </b-tooltip>
      </b-button>

      <b-button
        variant="success"
        class="my-2 me-2 rounded"
        :disabled="isLock"
        @click="onClickRenouvellement"
        id="modal-renouvellement-btn"
      >
        <span class="parc-btn-label">Renouvellement(s)</span>
        <i class="fa fa-file parc-icon"></i>
        <b-tooltip target="#modal-renouvellement-btn">
          {{ isRenouvellement ? 'Consulter les renouvellements' : 'Indiquer un renouvellement' }}
        </b-tooltip>
      </b-button>
    </div>
  </div>
</template>

<script setup>
import {BButton, BTooltip, useModal} from "bootstrap-vue-next";
import {onMounted, ref} from "vue";
import {useStoreGetters} from '@/composables/useStore'

const someConditions = ref(false)

defineProps({
  showModalAll: Function,
  onClickEditer: Function,
  onClickRenouvellement: Function,
})

onMounted(() => {
  someConditions.value = true
})

const {show: showGun} = useModal('modal-gun')

// Getters
const {
  parc,
  isDreal,
  isAutorisation,
  isAnteDebutConstruction,
  isLock,
  isRenouvellement,
  isAdministrateur,
  isAdministrateurRegionParc
} = useStoreGetters([
  'parc',
  'isDreal',
  'isAutorisation',
  'isAnteDebutConstruction',
  'isLock',
  'isRenouvellement',
  'isAdministrateur',
  'isAdministrateurRegionParc'
]);

const showDrealEditBtn = () => {
  return (!isAdministrateur || (isAdministrateur && isAdministrateurRegionParc));
};

</script>
